// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Fam0","topBottomGutter":"Layout_topBottomGutter__2VCT9"};